/* eslint-disable indent */
import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  Input,
  Button,
  Table,
  Row,
  // Col,
  message,
  Tooltip,
  Spin,
  Select,
  DatePicker,
  Col,
  Card,
} from "antd";
import { useNavigate } from "react-router";
import {
  capitaliseWithHyphen,
  // checkNumbervalue,
  // checkSpace,
  // checkSpecialCharacter,
  serialNum,
  dateFormat_dmy,
  commonSorterForTable,
  normalizeString,
  getUserAndPremiseId,
} from "../../../utils";
import { getPremiseId } from "../../../utils/worker";
const { RangePicker } = DatePicker;
import { camelCase } from "../../../utils";
import search_icon from "../../../assests/images/search-icon.svg";
import { ReactComponent as Copy_Icon } from "../../../assests/images/SVG/copy-icon.svg";
// import urls from "../../../api/urls";
import API from "../../../api";
// import urls from "../../../api/urls";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
//import { APIs } from "../../../utils/worker";
import { ReactComponent as Scan_check } from "../../../assests/images/SVG/check.svg";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import ScannedShipment from "../../../components/ScannedShipment";
import nodeURL from "../../../api/nodeUrls";
// const { NEW_INSCAN } = urls;
const { MANIFEST_DATE_FILTER_NODE, NEW_INSCAN_BATCH } = nodeURL;
// const premiseId = getPremiseId();

const InScan = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showtoolTip, setShowtoolTip] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [listCount, setListCount] = useState(0);
  const [dateRangeData, setDateRangeData] = useState([]);
  const [lastDate, setLastDate] = useState({});
  const [dateRangeStatus, setDateRangeStatus] = useState(false);
  const [filterType, setFilterType] = useState("both");
  const [serviceFilter, setServiceFilter] = useState("");
  const [typeFilter, setTypeFilter] = useState("");
  const [bookingtypeFilter, setBookingtypeFilter] = useState("");

  const [scannedAndTotalCount, setScannedAndTotalCount] = useState({});

  const [sortedInfo, setSortedInfo] = useState({});
  const [scanInputValue, setScanInputValue] = useState("");

  // Helper function to get deviceId
  const getDeviceId = () => {
    let deviceId = localStorage.getItem("device_id");
    if (!deviceId) {
      deviceId = crypto.randomUUID();
      localStorage.setItem("device_id", deviceId);
    }
    return deviceId;
  };

  const handleScan = async (id) => {
    setLoading(true);

    try {
      // Split comma-separated barcode values into an array
      const barcodeNumbers = id
        ?.split(",")
        ?.map((barcode) => barcode?.trim())
        ?.filter((barcode) => barcode?.length > 0);

      if (!barcodeNumbers || barcodeNumbers.length === 0) {
        setLoading(false);
        message.error("Please provide valid barcode numbers");
        return;
      }

      // Get user data
      const userData = JSON.parse(localStorage.getItem("userinfo"));
      const getUserInfo = getUserAndPremiseId();
      const userId = getUserInfo?.userId;
      const premiseIdObj = getPremiseId();
      const premiseId = premiseIdObj?.split("Bearer")[1];
      const deviceId = getDeviceId();

      // Prepare request body
      const requestBody = {
        barcodeNumbers: barcodeNumbers,
        premiseId: parseInt(premiseId),
        userId: parseInt(userId),
      };

      // Make API call to batch endpoint
      const response = await axios.post(NEW_INSCAN_BATCH, requestBody, {
        headers: {
          "Content-Type": "application/json",
          "smcs-premise-id": premiseId,
          "user-id": userId.toString(),
          "device-id": deviceId,
          Authorization: "Bearer " + userData?.accessToken,
          "X-Request-ID": uuidv4(),
        },
      });

      if (response?.status === 200 || response?.status === 201) {
        setLoading(false);
        let data = response?.data;

        // Handle response - check if it's a string or object
        let responseMessage = "";
        if (typeof data === "string") {
          responseMessage = data;
        } else if (data?.message) {
          responseMessage = data.message;
        } else if (data?.data) {
          responseMessage = data.data;
        }

        if (responseMessage?.split(" ")?.includes("Misrouted")) {
          message.config({ top: 50 });
          message.warning(responseMessage);
        } else {
          message.config({ top: 50 });
          message.success(
            responseMessage || barcodeNumbers.join(", ") + " scanned successfully"
          );
        }

        // Update table data for all scanned barcodes
        const updatedTableData = tableData?.map((obj) => {
          const isScanned = barcodeNumbers.some(
            (barcode) => obj?.awbNumber == barcode?.replace(/[a-zA-Z]/g, "")
          );
          return {
            ...obj,
            bookingStatus: isScanned ? "Inscanned" : obj?.bookingStatus,
          };
        });
        setTableData(updatedTableData);

        // Clear input field after successful scan
        setScanInputValue("");
      } else {
        setLoading(false);
        message.config({ top: 50 });
        message.error("Network error");
      }
    } catch (error) {
      setLoading(false);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Network error occurred";
      message.error(errorMessage);
    }
  };

  // let filterByManifest = () => {
  //   const unique = [
  //     ...new Map(tableData?.map((item) => [item["manifestId"], item])).values(),
  //   ];

  //   let data = unique?.map((val) => {
  //     return { text: val?.manifestId, value: val?.manifestId };
  //   });

  //   return data;
  // };

  function copyText(text) {
    setShowtoolTip(!showtoolTip);
    navigator.clipboard.writeText(text);
  }

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
  };

  // function convertToIST(isoDateString) {
  //   // Convert to Date object
  //   const date = new Date(isoDateString);

  //   // Options for formatting the date to IST
  //   const options = {
  //     timeZone: "Asia/Kolkata",
  //     year: "numeric",
  //     month: "2-digit",
  //     day: "2-digit",
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     second: "2-digit",
  //     hour12: false, // Use 24-hour time format
  //   };

  //   // Format the date to IST
  //   const formatter = new Intl.DateTimeFormat("en-GB", options);
  //   const formattedDate = formatter.format(date);

  //   return formattedDate;
  // }

  const convertDate = (isoDate) => {
    return moment.utc(isoDate).format("DD/MM/YYYY HH:mm");
  };

  const columns = [
    {
      title: "Sl No",
      align: "center",
      // width: 10,
      render: (a, b, idx) => serialNum(pageSize, currentPage, idx),
    },
    {
      title: "Awb No/Packet Id",
      dataIndex: "awbNumber",
      width: 210,
      key: "awbNumber",
      sorter: (a, b) => commonSorterForTable(a, b, "bookingStatus"),
      sortOrder:
        sortedInfo?.columnKey === "awbNumber" ? sortedInfo?.order : null,
      render: (text, val) => {
        const isLong = text && text.length > 14;
        const awbDisplay = isLong ? (
          <span className="awb-text awb-text-long">
            {text.slice(0, 14)}<br />{text.slice(14)}
          </span>
        ) : (
          <span className="awb-text">{text}</span>
        );
        return (
          <div className="awb-col-responsive">
            <div className="awb-main-row">
              {awbDisplay}
              <Tooltip title={showtoolTip ? "Copied" : "Copy"}>
                <span
                  className="copy-icon pointer"
                  onClick={() => copyText(text)}
                >
                  <Copy_Icon />
                </span>
              </Tooltip>
              {scannedStatusCheck(val) && <Scan_check />}
            </div>
          </div>
        );
      },
    },

    // {
    //   title: "Manifest ID",
    //   dataIndex: "manifestId",
    //   filters: filterByManifest(),
    //   width: 150,
    //   onFilter: (value, record) => record?.manifestId === value,
    //   key: "manifestId",
    // },

    {
      title: "Date",
      dataIndex: "createDate",
      key: "createDate",
      sorter: (a, b) => commonSorterForTable(a, b, "createDate"),
      sortOrder:
        sortedInfo?.columnKey === "createDate" ? sortedInfo?.order : null,
      ellipsis: true,
      // render: (text) => <span>{text ? text.split("T")[0] : "----"}</span>,
      render: (text) => <span>{text ? convertDate(text) : "----"}</span>,
    },
    {
      title: "CP Name",
      dataIndex: "premiseName",
      key: "premiseName",
      sortOrder:
        sortedInfo.columnKey === "premiseName" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "premiseName"),
      ellipsis: true,
      render: (text) => <div>{capitaliseWithHyphen(text)}</div>,
    },
    {
      title: "Doc Type",
      dataIndex: "type",
      key: "type",
      sortOrder: sortedInfo.columnKey === "type" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "type"),
      render: (text) => <div>{capitaliseWithHyphen(text)}</div>,
    },
    {
      title: "Service Type",
      dataIndex: "service",
      key: "service",
      sorter: (a, b) => commonSorterForTable(a, b, "service"),
      sortOrder: sortedInfo.columnKey === "service" ? sortedInfo.order : null,
      render: (text) => <div>{camelCase(text)}</div>,
    },
    {
      title: "Mode",
      dataIndex: "travelBy",
      key: "travelBy",
      sorter: (a, b) => commonSorterForTable(a, b, "travelBy"),
      sortOrder: sortedInfo.columnKey === "travelBy" ? sortedInfo.order : null,
      render: (text) => <div>{camelCase(text)}</div>,
    },
    {
      title: "Booking Type",
      dataIndex: "bookingType",
      key: "bookingType",
      sortOrder: sortedInfo.columnKey === "bookingType" ? sortedInfo.order : null,
      sorter: (a, b) => commonSorterForTable(a, b, "bookingType"),
      render: (text) => <div>{capitaliseWithHyphen(text)}</div>,
    },

    {
      title: "Status",
      dataIndex: "bookingStatus",
      key: "bookingStatus",
      sorter: (a, b) => commonSorterForTable(a, b, "bookingStatus"),
      sortOrder:
        sortedInfo.columnKey === "bookingStatus" ? sortedInfo.order : null,
      render: (text) => <div>{normalizeString(text)}</div>,
    },
  ];

  function naviGateBack() {
    navigate("/middle-mile");
  }

  function onPageChange(currentPage, pageSize) {
    // console.log(currentPage, "currentPage");
    // console.log(pageSize, "pageSize");

    if (dateRangeStatus) {
      dateSearchFun(currentPage, pageSize);
    }
    setCurrentPage(currentPage);
    setPageSize(pageSize);
  }

  // const onChange = (pagination, filters, sorter, extra) => {
  //   console.log(pagination, " on page hello");

  //   setCurrentPage(pagination?.current);
  //   setPageSize(pagination?.pageSize);
  //   let totalScann = extra.currentDataSource?.filter((val) => {
  //     return val?.bookingStatus !== "MANIFESTED";
  //   });

  //   return setTotalScanned({
  //     tableTotal: extra.currentDataSource.length,
  //     scannedCount: totalScann?.length,
  //   });
  // };

  //--Barcode Scanner--//
  let barcode = "";
  let interval;
  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleScan(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    // cleanup this component
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [tableData]);

  const onSearch = (e) => {
    if (e.target.value.length > 0) {
      setFilterType("both");
      setServiceFilter("");
      setTypeFilter("");
      setBookingtypeFilter("");
      dateSearchFun(undefined, undefined, "", e.target.value, undefined, "", "", "");
    } else {
      dateSearchFun(undefined, undefined, "", "", undefined, "", "", "");
    }
  };

  function handlefilterChange(params) {
    setFilterType(params.toLowerCase());
    setServiceFilter("");
    setTypeFilter("");
    setBookingtypeFilter("");
    dateSearchFun(undefined, undefined, params.toLowerCase(), "", undefined, "", "", "");
  }

  const handleServiceFilterChange = (value) => {
    const newValue = value || undefined;
    setServiceFilter(newValue || "");
    // Use the new value directly instead of relying on state
    dateSearchFun(undefined, undefined, filterType, "", undefined, newValue || "", typeFilter, bookingtypeFilter);
  };

  const handleTypeFilterChange = (value) => {
    const newValue = value || undefined;
    setTypeFilter(newValue || "");
    // Use the new value directly instead of relying on state
    dateSearchFun(undefined, undefined, filterType, "", undefined, serviceFilter, newValue || "", bookingtypeFilter);
  };

  const handleBookingTypeFilterChange = (value) => {
    const newValue = value || undefined;
    setBookingtypeFilter(newValue || "");
    // Use the new value directly instead of relying on state
    dateSearchFun(undefined, undefined, filterType, "", undefined, serviceFilter, typeFilter, newValue || "");
  };

  const applyFilters = (service = serviceFilter, type = typeFilter, bookingType = bookingtypeFilter) => {
    dateSearchFun(undefined, undefined, filterType, "", undefined, service, type, bookingType);
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = dd + "-" + mm + "-" + yyyy;
    const formattedYes =
      dd == "01"
        ? dd + "-" + mm + "-" + yyyy
        : (dd <= 10 ? "0" + (+dd - 1) : +dd - 1) + "-" + mm + "-" + yyyy;
    // console.log(formattedYes);
    let rangeData = [formattedYes, formattedToday];
    dateRangeHandle("", rangeData);
    setLastDate({ fromDate: rangeData[0] || "", toDate: rangeData[1] || "" });
    // Reset filters to default values
    setServiceFilter("");
    setTypeFilter("");
    setBookingtypeFilter("");
    dateSearchFun(undefined, undefined, "", "", rangeData, "", "", "");
  }, []);

  const dateRangeHandle = (e, a) => {
    setLastDate({ fromDate: a[0] || "", toDate: a[1] || "" });
    setDateRangeData(a);
    if (a[0]?.length === 0) {
      // getTableData();
      setDateRangeStatus(false);
    } else {
      setDateRangeStatus(true);
      // Reset filters when date range changes
      setServiceFilter("");
      setTypeFilter("");
      setBookingtypeFilter("");
    }
  };

  const dateConversion = (inputDate) => {
    const parsedDate = moment(inputDate, "DD-MM-YYYY");

    // Format the date to MM-DD-YYYY
    const formattedDate = parsedDate.format("MM-DD-YYYY");
    return formattedDate;
  };
  const dateSearchFun = async (
    currentPageNo,
    pageSiz,
    fil,
    searchInput,
    rangeData,
    serviceFilterParam,
    typeFilterParam,
    bookingTypeFilterParam
  ) => {
    setLoading(true);
    let dateData = rangeData ? rangeData : dateRangeData;
    let queryParams = searchInput
      ? `&search=${searchInput}&filter=both`
      : `&filter=${fil ? fil : filterType}`;

    // Use the passed parameters or fall back to state values
    const currentServiceFilter = serviceFilterParam;
    const currentTypeFilter = typeFilterParam;
    const currentBookingTypeFilter = bookingTypeFilterParam;

    // Add new filter parameters
    console.log("serviceFilter", currentServiceFilter);
    console.log("typeFilter", currentTypeFilter);
    console.log("bookingtypeFilter", currentBookingTypeFilter);
    if (currentServiceFilter && currentServiceFilter !== "") {
      queryParams += `&serviceFilter=${currentServiceFilter}`;
    }
    if (currentTypeFilter && currentTypeFilter !== "") {
      queryParams += `&typeFilter=${currentTypeFilter}`;
    }
    if (currentBookingTypeFilter && currentBookingTypeFilter !== "") {
      queryParams += `&bookingTypeFilter=${currentBookingTypeFilter}`;
    }

    // Get active hub or user premise id
    const activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
    const userMap = JSON.parse(localStorage.getItem("userinfo") || "{}");
    let selectedSameHubId = activeHub?.hubId || userMap?.premises?.premiseId;

    let response = await API.Api(
      `${MANIFEST_DATE_FILTER_NODE}?pageNum=${currentPageNo - 1 || 0
      }&pageSize=${pageSiz || 100}&fromDate=${dateConversion(
        dateData[0]
      )}&toDate=${dateConversion(dateData[1])}` + queryParams + `&hubId=${selectedSameHubId}`
    ).NodeGetWithPremise();
    if (response?.status) {
      let list = response?.response?.data?.consolidatedDto;
      let data = response?.response?.data;

      setTableData(
        list?.sort(function (a, b) {
          return a?.bookingStatus !== "MANIFESTED"
            ? 1
            : b?.bookingStatus != "MANIFESTED"
              ? -1
              : 0;
        })
      );

      // setDataSource(list);
      setListCount(data?.totalCount);
      let obj = {
        totalCount: data?.totalCount,
        totalScanned: data?.totalScanned,
      };
      setScannedAndTotalCount(obj);

      setLoading(false);
    } else {
      setTableData([]);
      setListCount(0);

      setLoading(false);
      message.config({ top: 50 });
      message.error(
        response?.response?.data?.message || "Internal server error."
      );
    }
  };

  const disabledDate = (current) => {
    if (!current) return false; // If no date, do not disable

    // Get today's date
    const today = moment();
    // Calculate the date range for the last 15 days
    const startDate = today?.clone()?.subtract(15, "days")?.startOf("day");
    const endDate = today?.clone()?.endOf("day");

    // Disable dates that are outside the range
    return current < startDate || current > endDate;
  };

  const scannedStatusCheck = (status) =>
    status?.bookingStatus !== "MANIFESTED" &&
    status?.bookingStatus !== "OUT_FOR_DELIVERY";

  // let scannedCount = tableData?.reduce(
  //   (acc, item) => scannedStatusCheck(item) && (acc += 1),
  //   0
  // );

  const [isPressed, setIsPressed] = useState(false);

  const handlePressEnter = (e) => {
    if (!isPressed) {
      setIsPressed(true);
      handleScan(e);
      setTimeout(() => {
        setIsPressed(false);
      }, 100);
    }
  };

  return (
    <>
      <Spin
        spinning={loading}
        indicator={
          <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
        }
      >
        <div className="consolidated-manifest-cntr">
          <div className="new-header ml-1">
            <Card className="filter-card">
              <Row gutter={[16, 16]} className="filters-section">
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="filter-label">AWB Scan</div>
                  <Input
                    value={scanInputValue}
                    onChange={(e) => setScanInputValue(e.target.value)}
                    placeholder="Enter AWB number(s) to scan (comma-separated)"
                    bordered
                    style={{
                      borderRadius: "5px",
                      height: "40px",
                    }}
                    suffix={false}
                    onKeyPress={(e) => {
                      // Allow comma for comma-separated values, but block other special characters
                      const forbiddenChars = /[@!$#%^&*=+()""';?.><]/;
                      if (forbiddenChars.test(e.key)) {
                        e.preventDefault();
                        message.destroy();
                        //message.error("Special characters @,!,$,#,%,^,&,*,=,+,(,) are not allowed in AWB number");
                      }
                    }}
                    onPressEnter={(e) => {
                      const value = e.target.value;
                      const storedPattern = localStorage.getItem("regexPattern");
                      if (value.length > 0) {
                        // Split by comma and validate each barcode if pattern exists
                        if (storedPattern) {
                          const cleanPattern = storedPattern?.replace(/^\/|\/$/g, "");
                          const regex = new RegExp(cleanPattern);
                          const barcodes = value.split(",").map(b => b.trim()).filter(b => b.length > 0);

                          // Validate each barcode individually
                          const invalidBarcodes = barcodes.filter(barcode => !regex.test(barcode));
                          if (invalidBarcodes.length > 0) {
                            message.destroy();
                            message.error("Invalid AWB number format");
                            return;
                          }
                        }
                        message.destroy();
                        handlePressEnter(value);
                      } else {
                        message.destroy();
                      }
                    }}
                  />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="filter-label">Date Range</div>
                  <div className="flex-start">
                    <RangePicker
                      disabledDate={disabledDate}
                      onChange={dateRangeHandle}
                      value={[
                        Object.keys(lastDate)?.length > 0 &&
                          lastDate?.fromDate !== ""
                          ? moment(
                            lastDate?.fromDate?.replaceAll("-", "/"),
                            dateFormat_dmy
                          )
                          : "",
                        Object.keys(lastDate)?.length > 0 &&
                          lastDate?.toDate !== ""
                          ? moment(
                            lastDate?.toDate?.replaceAll("-", "/"),
                            dateFormat_dmy
                          )
                          : "",
                      ]}
                      format={dateFormat_dmy}
                      style={{
                        borderRadius: "5px 0 0 5px",

                      }}
                    />
                    <Button
                      className="center mr-1"
                      disabled={!dateRangeStatus}
                      style={{
                        width: "40px",
                        height: "40px",
                        border: "1px solid #d9d9d9",
                        borderRadius: "0 5px 5px 0",
                      }}
                      onClick={() => applyFilters()}
                    >
                      <img src={search_icon} />
                    </Button>
                  </div>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="filter-label">AWB Search</div>
                  <Input
                    className="mr-1"
                    placeholder="Enter AWB number to search"
                    onChange={onSearch}
                    bordered
                    style={{
                      borderRadius: "5px",
                      height: "40px",
                    }}
                    maxLength={20}
                    suffix={<img src={search_icon} />}
                    onKeyPress={(e) => {
                      const forbiddenChars = /[@!$#%^&*=+()]/;
                      if (forbiddenChars.test(e.key)) {
                        e.preventDefault();
                        message.destroy();
                      }
                    }}
                  />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="filter-label">Scan Status</div>
                  <Select
                    defaultValue="both"
                    className="filter-select"
                    style={{
                      width: "100%",
                    }}
                    disabled={!dateRangeStatus || tableData?.length == 0}
                    value={filterType}
                    onChange={handlefilterChange}
                    options={[
                      {
                        value: "scanned",
                        label: "Scanned",
                      },
                      {
                        value: "un-scanned",
                        label: "Unscanned",
                      },
                      {
                        value: "both",
                        label: "Both",
                      },
                    ]}
                  />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="filter-label">Service Type</div>
                  <Select
                    className="filter-select"
                    style={{
                      width: "100%",
                    }}
                    value={serviceFilter || undefined}
                    onChange={handleServiceFilterChange}
                    placeholder="Service Type"
                    allowClear
                    options={[
                      {
                        value: "Standard",
                        label: "Standard",
                      },
                      {
                        value: "Fast Track",
                        label: "Fast Track",
                      },
                      {
                        value: "Value Plus",
                        label: "Value Plus",
                      },
                      {
                        value: "vayuquick",
                        label: "Vayuquick",
                      },
                      {
                        value: "vayuquick_pro",
                        label: "Vayuquick Pro",
                      },
                      {
                        value: "E_comm",
                        label: "E-comm",
                      },
                    ]}
                  />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="filter-label">Document Type</div>
                  <Select
                    className="filter-select"
                    style={{
                      width: "100%",
                    }}
                    value={typeFilter || undefined}
                    onChange={handleTypeFilterChange}
                    placeholder="Document Type"
                    allowClear
                    options={[
                      {
                        value: "dox",
                        label: "Dox",
                      },
                      {
                        value: "non-dox",
                        label: "Non-Dox",
                      },
                    ]}
                  />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="filter-label">Booking Type</div>
                  <Select
                    className="filter-select"
                    style={{
                      width: "100%",
                    }}
                    value={bookingtypeFilter || undefined}
                    onChange={handleBookingTypeFilterChange}
                    placeholder="Booking Type"
                    allowClear
                    options={[
                      {
                        value: "ECOMM",
                        label: "E-COMM",
                      },
                      {
                        value: "CARGO",
                        label: "CARGO",
                      },
                      {
                        value: "COURIER",
                        label: "COURIER",
                      },
                      {
                        value: "INTERNATIONAL",
                        label: "INTERNATIONAL",
                      },
                    ]}
                  />
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <div className="filter-label">Scanned Summary</div>
                  <ScannedShipment
                    className="mr-1"
                    scannedData={scannedAndTotalCount?.totalScanned}
                    totalData={scannedAndTotalCount?.totalCount}
                    slug={"/consolidated-manifest"}
                    filterType={filterType}
                  />
                </Col>
              </Row>
            </Card>
          </div>
          <Table
            columns={columns}
            scroll={{
              x: 1500,
              // y: 500,
            }}
            dataSource={
              tableData
                ? [
                  // eslint-disable-next-line no-unsafe-optional-chaining
                  ...tableData?.sort(function (a, b) {
                    return a?.bookingStatus === "Inscanned"
                      ? 1
                      : b?.bookingStatus === "Inscanned"
                        ? -1
                        : 0;
                  }),
                ]
                : []
            }
            // loading={loading}
            onChange={handleChange}
            className="table-head-sticky"
            pagination={{
              pageSizeOptions: ["50", "100", "500", "1000"],
              pageSize: pageSize,
              total: listCount,
              current: currentPage,
              itemRender: itemRender,
              onChange: onPageChange,
            }}
          />
        </div>
        <Row className="flex-end mt-2">
          <Button
            className="save-btn"
            style={{ textAlign: "end" }}
            onClick={naviGateBack}
          // disabled={checkInScanned}
          >
            DONE
          </Button>
        </Row>
      </Spin>
    </>
  );
};

export default InScan;
